<template>
  <div class="category-list-item">
    <img v-if="iconUrl" :src="iconUrl" :alt="name || ''" class="icon" />
    <div class="meta">
      <router-link v-if="route" :to="route" class="name">{{
        name
      }}</router-link>
      <div v-else class="name">{{ name }}</div>
      <div v-if="showPackageCount" class="count">
        มีทั้งหมด {{ packageCount }} package
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    packageCount: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    showPackageCount() {
      return this.packageCount !== null
        && this.packageCount !== undefined
        && this.packageCount !== "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$iconSize: 48px;

.category-list-item {
  display: grid;
  grid-template-columns: 48px auto;
  grid-gap: 30px;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .icon {
    display: block;

    border-radius: 8px;
    width: $iconSize;
    height: $iconSize;
  }

  > .meta {
    display: block;
  }
}

.meta > .name {
  line-height: 1.6;
  display: inline-block;

  &:hover {
    color: black;
  }
}

.count {
  font-size: 14px;
}
</style>
